export type ToggleProps = {
  size?: "20" | "24";
  disabled?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

export default function Toggle(props: ToggleProps) {
  const getContainerClasses = () => {
    const baseClasses =
      "relative flex items-center transition-colors duration-200 ease-in-out rounded-3xl";
    const sizeClasses = props.size === "20" ? "w-8 h-5" : "w-10 h-6";
    const colorClasses =
      props.checked && !props.disabled ? "bg-success-500" : "bg-fills-grey-3"; // Fills/Grey 3 for inactive state

    return `${baseClasses} ${sizeClasses} ${colorClasses}`;
  };

  const getKnobClasses = () => {
    const baseClasses =
      "absolute transition-transform duration-200 ease-in-out rounded-full"; // Background/Primary
    const sizeClasses = props.size === "20" ? "w-4 h-4" : "w-5 h-5";
    const positionClasses = props.checked
      ? "translate-x-[calc(100%-2px)]"
      : "translate-x-[2px]";
    const colorClasses = props.disabled ? "bg-fills-grey-4" : "bg-[#ffffff]";

    return `${baseClasses} ${sizeClasses} ${positionClasses} ${colorClasses}`;
  };

  const handleClick = () => {
    if (!props.disabled && props.onChange) {
      props.onChange(!props.checked);
    }
  };

  return (
    <button
      type="button"
      class={getContainerClasses()}
      onClick={handleClick}
      disabled={props.disabled}
      role="switch"
      aria-checked={props.checked}
    >
      <span class={getKnobClasses()} />
    </button>
  );
}
